export default __webpack_public_path__ + "static/about_dig_deeper-ab8d0389ad1565f8e9857c767aeb6a23.mp4";